// import ReactTooltip from 'react-tooltip';
import Text from '../../../atoms/Text';

import './styles.scss';

export type FeatureTableRow =
  | {
      type: 'mark';
      value: boolean;
    }
  | {
      type: 'text_with_question_mark';
      value: string;
      tooltip: string;
    }
  | {
      type: 'text';
      value: string | number;
    }
  | {
      type: 'text_with_mark';
      mark: boolean;
      value: string;
    };

interface IFeatureTableProps {
  rows: FeatureTableRow[];
  color: string;
  weight: number;
}

const FeatureTable = ({ rows, color, weight }: IFeatureTableProps) => {
  return (
    <div className='feature_table'>
      {rows.map((row, index) => {
        if (row.type === 'mark') {
          return (
            <div key={index} className='feature_table__row'>
              <div
                className={
                  row.value
                    ? 'feature_table__row__tick icon-check'
                    : 'feature_table__row__cross icon-close'
                }
              />
            </div>
          );
        }
        if (row.type === 'text') {
          return (
            <div
              key={index}
              className='feature_table__row feature_table__row--text'
            >
              <Text size={14} style={{ style: { color } }}>
                {row.value}
              </Text>
            </div>
          );
        }
        if (row.type === 'text_with_mark') {
          return (
            <div key={index} className='feature_table__row'>
              <div
                className={
                  row.mark
                    ? 'feature_table__row__tick icon-check'
                    : 'feature_table__row__cross icon-close'
                }
              />
              <Text size={14} style={{ style: { color } }}>
                {row.value}
              </Text>
            </div>
          );
        }
        return (
          <div key={index} className='feature_table__row'>
            <Text size={14} style={{ style: { color, fontWeight: weight } }}>
              {row.value}
            </Text>
            {/* <div
              data-for={`feature-table-tooltip-${row.value}-${row.tooltip}`}
              data-tip={row.tooltip}
              className='feature_table__row__question icon-tooltip-circle'
            />
            <ReactTooltip
              id={`feature-table-tooltip-${row.value}-${row.tooltip}`}
              place='right'
              effect='solid'
              className='text_tooltip'
            /> */}
          </div>
        );
      })}
    </div>
  );
};

export default FeatureTable;
